export default __webpack_public_path__ + "static/media/obs_step2.d11a2b1f.png";